import type { ClinicalRuntime } from "../auth/ClinicalRuntimeProvider";
import { conversationRows } from "../lib/documentInbox";
import {
  isInAttentionScope,
  useAttentionConversations,
  useAttentionInbox,
} from "../lib/useAttentionInbox";

export function AttentionBadge({ runtime }: { runtime: ClinicalRuntime }) {
  const { client, profile, rows } = useAttentionInbox(runtime);
  const conversations = useAttentionConversations(client, runtime.config.siteId);
  const count = [
    ...rows,
    ...conversationRows(
      conversations.data?.pages.flatMap((page) => page.items) ?? [],
      profile.data?.userId ?? "",
    ),
  ].filter(
    (row) => row.bucket === "action" && isInAttentionScope(row, profile.data, "mine"),
  ).length;
  if (count === 0) return null;
  return (
    <span
      className="nav-badge"
      role="status"
      aria-label={`${count} item${count === 1 ? "" : "s"} needing attention`}
    >
      {count}
    </span>
  );
}
